import PassCover from 'icons/pass-cover'
import PassLogo from 'icons/pass-logo'
import { QRCodeCanvas } from 'qrcode.react'
import React from 'react'
import { invertTextColor, vcfText } from 'utils'

function GooglePass({ design, variant }) {
  const isBusiness = variant === 'business'
  const {
    backgroundColor,
    logoImage,
    stripImage,
    title,
    jobTitle,
    firstName,
    lastName,
    fullName,
    email,
    phone,
    phones,
    organisationName,
    companyURL,
    linkedInURL,
    socials,
    addresses,
    personalAccount,
    customFields = [],
  } = design

  const displayTitle = title || jobTitle || 'Pass Title'

  return (
    <div
      className='tw-w-full tw-max-w-[360px] tw-min-h-[520px] tw-shadow-[0_16px_40px_rgba(0,0,0,0.16)] tw-text-white tw-rounded-[32px] tw-overflow-hidden tw-flex tw-flex-col tw-border tw-border-white/20'
      style={{ backgroundColor: backgroundColor }}
    >
      <div className='tw-flex tw-flex-1 tw-flex-col tw-justify-between tw-pb-6 tw-w-full'>
        <div className='tw-relative tw-mt-[16px] tw-mr-[16px] tw-ml-[16px]'>
          <div className='tw-mb-[16px]'>
            <div className='tw-flex tw-flex-row tw-items-center'>
              <div className='tw-mr-[16px]'>
                <div className='tw-rounded-full tw-w-[40px] tw-m-0 tw-flex'>
                  {logoImage ? (
                    <img className='tw-w-full' src={logoImage} alt='Logo' />
                  ) : (
                    <div id='default-logo' className='tw-block tw-w-full tw-m-1'>
                      <PassLogo color={invertTextColor(backgroundColor)} />
                    </div>
                  )}
                </div>
              </div>
              <div style={{ color: invertTextColor(backgroundColor) }} />
            </div>

            {isBusiness ? (
              <div
                className='tw-text-[11px] tw-uppercase tw-mt-5 tw-tracking-[0.2em] tw-opacity-80 tw-whitespace-nowrap'
                style={{ color: invertTextColor(backgroundColor) }}
              >
                {displayTitle}
              </div>
            ) : (
              <>
                <div
                  className='tw-text-[12px] tw-uppercase tw-mt-5'
                  style={{ color: invertTextColor(backgroundColor) }}
                >
                  {jobTitle}
                </div>
                <div
                  className='tw-text-1xl tw-font-extralight'
                  style={{ color: invertTextColor(backgroundColor) }}
                >
                  Customer Name
                </div>
              </>
            )}

            <div
              className={
                isBusiness
                  ? 'tw-text-[18px] tw-font-semibold tw-mt-1 tw-leading-tight tw-whitespace-nowrap'
                  : 'tw-text-1xl tw-font-extralight'
              }
              style={{ color: invertTextColor(backgroundColor) }}
            >
              {fullName}
            </div>
          </div>

          <div className='tw-mt-[12px] tw-mb-[12px]'>
            <div className='tw-bg-white/95 tw-mt-5 tw-mx-auto tw-rounded-[16px] tw-card-qrcode tw-max-w-fit tw-p-[16px] tw-shadow-[0_8px_18px_rgba(0,0,0,0.12)]'>
              <QRCodeCanvas
                value={vcfText({
                  firstName,
                  lastName,
                  email,
                  phone,
                  phones,
                  jobTitle,
                  organisationName,
                  companyURL,
                  linkedInURL,
                  socials,
                  addresses,
                  personalAccount,
                })}
                viewBox='0 0 53 53'
                size={128}
              />
            </div>
            <p
              className='tw-card-qrcode-text tw-text-base tw-mt-[8px] tw-font-normal tw-text-center'
              style={{ color: invertTextColor(backgroundColor) }}
            >
              Save my contact details
            </p>
          </div>

          {isBusiness && customFields?.length > 0 ? (
            <div className='tw-mt-4 tw-rounded-[16px] tw-bg-white/10 tw-p-3 tw-backdrop-blur-sm'>
              {customFields.map((field, index) => (
                <div key={`${field.fieldName || 'field'}-${index}`} className='tw-mb-2 last:tw-mb-0'>
                  <div className='tw-text-[10px] tw-uppercase tw-font-semibold tw-tracking-[0.2em] tw-opacity-80'>
                    {field.fieldName || 'Field'}
                  </div>
                  <div className='tw-text-[13px] tw-font-medium tw-break-words'>
                    {field.fieldValue || '—'}
                  </div>
                </div>
              ))}
            </div>
          ) : null}
        </div>
      </div>

      {stripImage ? (
        <div className='tw-mt-auto tw-w-full tw-overflow-hidden tw-strip-preview tw-h-[180px] tw-bg-white/10'>
          <img className='tw-h-full tw-w-full tw-object-cover' src={stripImage} alt='Primary strip' />
        </div>
      ) : (
        <span id='default-strip' className='tw-flex tw-items-center tw-px-6 tw-w-full tw-aspect-[3/1]'>
          <div className='tw-mx-auto tw-w-2/3'>
            <PassCover color={invertTextColor(backgroundColor)} />
          </div>
        </span>
      )}
    </div>
  )
}

export default GooglePass
